import { call, options, params } from './helpers';

export const getLogs = (payload) => call(`/beta/logs${params(payload)}`);
